module.exports = __webpack_public_path__ + "assets/img/jewelryBox.fced5ade.png";